var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.event-editor-invite-modal",
      modifiers: {
        "event-editor-invite-modal": true
      }
    }],
    staticClass: "invite-button w-100 mb-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.openInviteModal
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require(`@/assets/customer-project/invite.svg`)
    }
  }), _vm._v(" " + _vm._s(_vm.$t('event-editors.invite-editor')) + " ")]), _c('custom-modal', {
    attrs: {
      "id": "event-editor-invite-modal",
      "icon": "customer-project/danger.svg",
      "size": "lg"
    },
    on: {
      "close": _vm.closeInviteModal
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.inviteSection,
            expression: "inviteSection"
          }]
        }, [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.inviteFailed,
            expression: "!inviteFailed"
          }],
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/invite-icon.svg")
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.inviteFailed,
            expression: "inviteFailed"
          }],
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-editors.modal.invite.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-editors.modal.invite.body')) + " ")]), _c('div', {
          staticClass: "form-container"
        }, [_c('event-editor-invite-form', {
          key: _vm.inviteFormKey,
          attrs: {
            "event-id": _vm.eventId,
            "error": _vm.inviteError,
            "loading": _vm.loading
          },
          on: {
            "submit": _vm.inviteEditor,
            "cancel": function ($event) {
              return _vm.$bvModal.hide('event-editor-invite-modal');
            }
          }
        })], 1)]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.inviteSection,
            expression: "!inviteSection"
          }]
        }, [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/invite-successful.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-editors.modal.success.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-editors.modal.success.body')) + " "), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.invitedEmail))])]), _c('div', {
          staticClass: "form-container"
        }, [_c('b-button', {
          staticClass: "w-100 modal-button-back",
          on: {
            "click": function ($event) {
              return _vm.$bvModal.hide('event-editor-invite-modal');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('back')) + " ")])], 1)])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }